import React from "react";
import { LivenessCheckContainer, LivenessCheckHeader, LivenessCheckBody } from "../styles";
import { Button } from "../../../components/common/Button";
import { ReactComponent as NextStepIcon } from "../icons/hourglass-Illustration.svg"

type Props = {
    action: () => void;
}

export default function LivenessCheckNotification({action}: Props) {
    return (
        <LivenessCheckContainer>
            <NextStepIcon/>
            <LivenessCheckHeader>
                What happens next?
            </LivenessCheckHeader>
            <LivenessCheckBody>
                After submission, the UBO and director(s) will receive an email to complete their details and liveness check.
            </LivenessCheckBody>
            <LivenessCheckBody>
                Check your email(s) for your verification link.
            </LivenessCheckBody>
            <Button theme="secondary" onClick={action}>
                Go to dashboard
            </Button>
        </LivenessCheckContainer>
    )
}